/* Add-to-cart confirmation for ported pages (Sam, 2026-09-22: the shopper stays on the page).
 *
 * Listens for `cart:item-add` (assets/product-form.js for the buy box, assets/bulk-matrix.js
 * for the bulk band) and `cart:surcharge-added` (assets/product-configurator.js, the keys or
 * numbering companion line that follows a configured padlock), then reads /cart.js and writes
 * the item count into every header count: `.head-slot-cart-link` ("Cart · N", desktop) and
 * `.head-slot-cart-count` (the drawer badge). The toast shows for five seconds or until closed.
 * `dc:cart-error` (assets/dc-card-add.js) shows the store's refusal in the same toast, without
 * the View cart link.
 * No drawer: the artboards draw none. */
(function () {
  var toast = document.querySelector('dc-cart-toast');
  if (!toast) return;
  var timer = null;
  var text = toast.querySelector('.dc-cart-toast-text');
  var link = toast.querySelector('.dc-cart-toast-link');
  var addedText = text ? text.textContent : '';

  function refreshCount() {
    return fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Padlocks, not their CHF 1 option units (companion lines carry _config_parent).
        var n = (cart.items || []).reduce(function (sum, item) {
          return item.properties && item.properties._config_parent ? sum : sum + item.quantity;
        }, 0);
        document.querySelectorAll('.head-slot-cart-count').forEach(function (el) { el.textContent = n; });
        document.querySelectorAll('.head-slot-cart-link').forEach(function (el) {
          el.textContent = el.textContent.replace(/\d+\s*$/, String(n));
        });
      })
      .catch(function () {});
  }

  function show(message) {
    if (text) text.textContent = message || addedText;
    if (link) link.hidden = !!message;
    toast.hidden = false;
    toast.classList.add('is-on');
    clearTimeout(timer);
    timer = setTimeout(hide, 5000);
  }
  function hide() {
    toast.classList.remove('is-on');
    clearTimeout(timer);
    timer = setTimeout(function () { toast.hidden = true; }, 220);
  }

  document.addEventListener('cart:item-add', function () {
    // The configurator's companion line lands right after the padlock; the count is read once
    // it has (cart:surcharge-added) or after a short grace when there is none.
    show();
    clearTimeout(toast._countTimer);
    toast._countTimer = setTimeout(refreshCount, 500);
  });
  document.addEventListener('dc:cart-error', function (event) {
    show((event.detail && event.detail.message) || addedText);
  });
  document.addEventListener('cart:surcharge-added', function () {
    clearTimeout(toast._countTimer);
    refreshCount();
  });
  var close = toast.querySelector('.dc-cart-toast-close');
  if (close) close.addEventListener('click', hide);
})();
